module.exports = __webpack_public_path__ + "img/sy_img_iot.947d79b7.png";